
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as CoreComponent from '@core/components'; 
import { LayoutComponent } from '@core/layouts';
import { MaterialModule } from '@core/material';
import { OverlayModule } from '@angular/cdk/overlay';
// Import PrimeNG Modules
import { PrimeNGModule } from '@modules/primeNG/primeNG.module';
//Pipe
import { SameDateDisplayPipe } from '@core/pipes';
//Directive
import { TargetBlankDirective, TooltipArrowAnchorDirective, TouchTooltipDirective } from '@core/directives';
import { LayoutTvComponent } from '@core/layouts/layout-tv/layout-tv.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

const COMPONENTS = [
  LayoutComponent,
  LayoutTvComponent,
  CoreComponent.HeaderComponent,
  CoreComponent.DialogLogoutComponent,
  CoreComponent.SidebarComponent,
  CoreComponent.SubheaderComponent,
  CoreComponent.ButtonComponent,
  CoreComponent.UserInfoComponent,
  CoreComponent.LabelComponent,
  CoreComponent.FieldActivityLogComponent,
  CoreComponent.FieldActivityItemComponent,
  CoreComponent.MutiScreenComponent,
  CoreComponent.DynamicLabelComponent,
  CoreComponent.GridDataComponent,
  CoreComponent.VitalComponent,
  CoreComponent.AttentionComponent,
  CoreComponent.TrainingComponent,
  CoreComponent.MealComponent,
  CoreComponent.MealMoistureComponent,
  CoreComponent.MealSnackComponent,
  CoreComponent.BatsuMaruComponent,
  CoreComponent.YesNoIndicatorComponent,
  CoreComponent.PaginationComponent,
  CoreComponent.ModalTemplateComponent,
  CoreComponent.TextboxComponent,
  CoreComponent.NumberBoxComponent,
  CoreComponent.SwitchButtonComponent,
  CoreComponent.RadioButtonComponent,
  CoreComponent.CheckboxComponent,
  CoreComponent.SelectBoxComponent,
  CoreComponent.MultiSelectBoxTvComponent,
  CoreComponent.SelectBoxTvComponent,
  CoreComponent.MultiSelectBoxComponent,
  CoreComponent.DialogTemplateComponent,
  CoreComponent.ConfirmDialogComponent,
  CoreComponent.CheckSheetSettingDialogComponent,
  CoreComponent.TitleSettingDialogComponent,
  CoreComponent.AnswerDialogComponent,
  CoreComponent.ElapsedTimeComponent,
  CoreComponent.TagInfoDialogComponent,
  CoreComponent.ExcreationSettingDialogComponent,
  CoreComponent.TextMarqueeComponent,
  CoreComponent.UIthemeComponent,
  CoreComponent.LeaveComponent,
  CoreComponent.StatusComponent,
  CoreComponent.BasicBarChartComponent,
  CoreComponent.FinalTreatmentComponent,
  CoreComponent.DualBarChartComponent,
  CoreComponent.FieldActivityHeaderComponent,
  CoreComponent.FieldActivityHeaderMonthComponent,
  CoreComponent.YoteiCheckListModalComponent,
  CoreComponent.AutoCompleteItemComponent,
  CoreComponent.ConditionItemComponent,
  CoreComponent.TreeNodeTitlesComponent,
  CoreComponent.TreenodeItemComponent,
  CoreComponent.LazyTreeViewComponent,
  CoreComponent.LazyTreeNodeComponent,
  CoreComponent.DropDownComponent,
  CoreComponent.DropDownPanelComponent,
  CoreComponent.ShowcaseComponent,
  CoreComponent.LogoTvComponent,
  CoreComponent.BlankTvComponent,
  CoreComponent.StartupTvComponent,
  CoreComponent.OfficeSelectTvComponent,
  CoreComponent.CorpSelectionTvComponent,
  CoreComponent.UserSettingMenuMidComponent,
  CoreComponent.UserSettingMenuRightComponent,
  CoreComponent.UsMenuRightCsNyushoComponent,
  CoreComponent.UsMenuRightCsTsuShoComponent,
  CoreComponent.UsMenuRightCsColumnComponent,
  CoreComponent.UsMenuRightCsConfigComponent,
  CoreComponent.TvScrollSelectorComponent,
  CoreComponent.DragAndDropTableComponent,
  CoreComponent.TitleYoteiDialogComponent,
  CoreComponent.BathDaiChangeConfirmDialogComponent,
  CoreComponent.BathdaiApplyResultDialogComponent,
  CoreComponent.CustomCalendarComponent
];

const DIRECTIVES = [
  TargetBlankDirective,
  TouchTooltipDirective,
  TooltipArrowAnchorDirective
];
const PIPES = [
  SameDateDisplayPipe
];

@NgModule({
  imports: [
    CommonModule, 
    RouterModule, 
    MaterialModule, 
    OverlayModule, 
    FormsModule, 
    ReactiveFormsModule,
    PrimeNGModule,
    DialogModule,
    ButtonModule,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    OverlayModule,
    PrimeNGModule,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES],
  providers: [

  ]
})
export class CoreModule { }
